import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_CategoryListComponent from "../components/_FM_category/_FM_CategoryListComponent";
import _FM_CategoryFormComponent from "../components/_FM_category/_FM_CategoryFormComponent";
import _FM_CategoryShowComponent from "../components/_FM_category/_FM_CategoryShowComponent";
import _FM_AccommodationImportFormComponent from "../components/_FM_accommodation/_FM_AccommodationImportFormComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_AccomodatonPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();

  useEffect(() => {
    document.title = t('residential_categories') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/category')
  }, []);

  return (
    <div className="_FM_CategoryPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/category"}/>
      <Panel>
        <_FM_CategoryListComponent />
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/category');
               }}>
        <_FM_CategoryFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/category');
               }}>
        <_FM_CategoryShowComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'import' && entity === 'accommodation'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/category');
               }}>
        <_FM_AccommodationImportFormComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_AccomodatonPage);
